// Lote 126 — regras da lista da Agenda (agrupar por dia, situação, mês, busca, ordem), sem nada de tela:
// funções puras, para poder testar sem navegador.

export const semAcento = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

const ehPrazo = (h) => (h?.hearing?.event_type || "audiencia") === "prazo";

// pendente  = ainda precisa de atenção: sem data, data de hoje em diante, ou PRAZO não concluído (mesmo vencido —
//             prazo vencido nunca some da lista padrão);
// ocorrido  = audiência/compromisso de dia anterior que não foi marcado como realizado;
// concluido = marcado como feito/realizado.
export function situacaoItem(h, hoje) {
  if (h?.prazo_done === true) return "concluido";
  const d = h?.hearing?.date;
  if (ehPrazo(h) || !d || d >= hoje) return "pendente";
  return "ocorrido";
}

// Texto em que a busca procura: partes, nº do processo (com e sem pontuação), vara, comarca, tipo de prazo/assunto.
export function textoBusca(h) {
  const x = h?.hearing || {};
  const partes = typeof x.parties === "string" ? x.parties : [x.party_author, x.party_defendant].filter(Boolean).join(" ");
  const num = String(x.case_number || "");
  return semAcento([partes, x.party_author, x.party_defendant, num, num.replace(/\D/g, ""), x.court, x.court_district,
    x.deadline_type, x.meeting_subject, x.meeting_participants, x.description].filter(Boolean).join(" "));
}

export function opcoesMes(items) {
  const s = new Set();
  (items || []).forEach((h) => { const d = h?.hearing?.date; if (d && /^\d{4}-\d{2}/.test(d)) s.add(d.slice(0, 7)); });
  return [...s].sort();
}

// Aplica busca + mês (a situação é decidida por quem monta as seções).
export function filtrarBuscaMes(items, { busca = "", mes = "todos" } = {}) {
  const q = semAcento(busca).trim();
  const qd = q.replace(/\D/g, "");
  return (items || []).filter((h) => {
    if (mes !== "todos" && !(h?.hearing?.date || "").startsWith(mes)) return false;
    if (!q) return true;
    const t = textoBusca(h);
    return t.includes(q) || (qd.length >= 4 && t.includes(qd));
  });
}

// [[ "2026-10-26", [itens do dia por horário] ], ...]; sem data vai por último. ordem: "asc" | "desc".
export function agruparPorDia(items, ordem = "asc") {
  const mapa = new Map();
  for (const h of items || []) {
    const k = h?.hearing?.date || "sem-data";
    if (!mapa.has(k)) mapa.set(k, []);
    mapa.get(k).push(h);
  }
  const hora = (h) => h?.hearing?.time || "99:99";
  const fator = ordem === "desc" ? -1 : 1;
  const grupos = [...mapa.entries()].map(([k, v]) => [k, v.slice().sort((a, b) => fator * hora(a).localeCompare(hora(b)))]);
  grupos.sort((a, b) => {
    if (a[0] === "sem-data") return 1;
    if (b[0] === "sem-data") return -1;
    return fator * a[0].localeCompare(b[0]);
  });
  return grupos;
}

const DIAS = ["DOMINGO", "SEGUNDA-FEIRA", "TERÇA-FEIRA", "QUARTA-FEIRA", "QUINTA-FEIRA", "SEXTA-FEIRA", "SÁBADO"];
const MESES = ["JANEIRO", "FEVEREIRO", "MARÇO", "ABRIL", "MAIO", "JUNHO", "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO"];

// "2026-10-26" -> "SEGUNDA-FEIRA · 26 OUTUBRO"
export function rotuloDia(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  if (!m) return "SEM DATA";
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return `${DIAS[d.getDay()]} · ${Number(m[3])} ${MESES[d.getMonth()]}`;
}

export function somaDias(iso, n) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  if (!m) return iso;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + n);
  const p = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

// Monta as seções da lista conforme a situação escolhida ("pendentes" | "concluidos" | "todos").
// Cada seção: { id, rotulo (ou null), grupos }. Pendentes seguem a `ordem`; o que já passou vem espelhado
// (mais recente primeiro quando a ordem é crescente).
export function montarSecoes(items, { situacao = "pendentes", ordem = "asc", hoje }) {
  const pend = [], ocor = [], conc = [];
  for (const h of items) {
    const s = situacaoItem(h, hoje);
    (s === "pendente" ? pend : s === "ocorrido" ? ocor : conc).push(h);
  }
  const inverso = ordem === "desc" ? "asc" : "desc";
  const secoes = [];
  if (situacao !== "concluidos" && pend.length) secoes.push({ id: "pendentes", rotulo: null, grupos: agruparPorDia(pend, ordem) });
  if (situacao !== "pendentes") {
    if (ocor.length) secoes.push({ id: "ocorridos", rotulo: "Realizadas", grupos: agruparPorDia(ocor, inverso) });
    if (conc.length) secoes.push({ id: "concluidos", rotulo: conc.every(ehPrazo) ? "Prazos concluídos" : "Concluídos", grupos: agruparPorDia(conc, inverso) });
  }
  return secoes;
}
